export default __webpack_public_path__ + "static/media/js.3dfb665e.png";